import { TipoProveedorOauth } from '../constants/tipo-proveedor-oauth.enum';
import { User, LoginFlow, CheckPhoneAvailabilityResponse } from './auth.types';

export const LoginState = {
  login: 1,
  confirmInformation: 2,
  accountDetected: 3,
  toAccess: 4,
  phoneVerification: 5,
  finish: 6,
} as const;

export type LoginStateType = (typeof LoginState)[keyof typeof LoginState];

// Base interface for all login states
interface BaseLoginState {
  type: LoginStateType;
  timestamp: Date;
}

// Specific state interfaces with their associated data
export interface LoginInitialState extends BaseLoginState {
  type: typeof LoginState.login;
  email?: string;
  error?: string;
}

export interface ConfirmInformationState extends BaseLoginState {
  type: typeof LoginState.confirmInformation;
  // TODO: Cuando sea por OAUTH es obligatorio el idToken
  loginFlow: {
    name?: string;
    email?: string;
    idProveedor: TipoProveedorOauth;
    idUsuarioProveedor?: string;
    photoUrl?: string;
    idToken?: string;
    redirectUrl?: string;
  };
}

export interface PhoneVerificationState extends BaseLoginState {
  type: typeof LoginState.phoneVerification;
  loginFlow: {
    name: string;
    email: string;
    idProveedor: TipoProveedorOauth;
    idUsuarioProveedor?: string;
    photoUrl?: string;
    idToken?: string;
    password?: string;
    redirectUrl?: string;
  };
}

export interface AccountDetectedState extends BaseLoginState {
  type: typeof LoginState.accountDetected;
  loginFlow: {
    name: string;
    email: string;
    idProveedor: TipoProveedorOauth;
    telefono: string;
    prefijoTelefono: string;
    idUsuarioProveedor?: string;
    photoUrl?: string;
    idToken?: string;
    password?: string;
    redirectUrl?: string;
  };
  // foundUserData: User;
  foundPhoneData?: CheckPhoneAvailabilityResponse;
}

export interface ToAccessState extends BaseLoginState {
  type: typeof LoginState.toAccess;
  loginFlow: {
    idEmail: number;
    email: string;
    idUsuarioDigital: number;
    idTelefono: number;
    telefono: string;
    prefijoTelefono: string;
  };
  availableMethods: ('email' | 'sms' | 'password')[];
}

export interface FinishState extends BaseLoginState {
  type: typeof LoginState.finish;
  user: User;
  loginFlow: {
    name: string;
    email: string;
    idProveedor: TipoProveedorOauth;
    idToken?: string;
  };
  success: boolean;
  redirectUrl?: string;
}

// Discriminated union of all possible login states
export type LoginStateObject =
  | LoginInitialState
  | ConfirmInformationState
  | AccountDetectedState
  | ToAccessState
  | PhoneVerificationState
  | FinishState;
